// The part of a cancellation draft that leads a list of new times.
//
// The server writes two paragraphs after a cancellation: the fact ("your
// Monday at 1:00 PM has been cancelled") and an invitation ("would you like
// another time?"). When the office then picks times, the fact must stay and
// the question must go - a question followed by its own answer reads oddly
// in a text to a patient.
export function cancellationLead(draft: string | null | undefined): string {
  const text = String(draft || '').trim();
  if (!text) return '';
  return text.split(/\n\s*\n/)[0].trim();
}
